import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { updateQueryParams } from "@/scripts/common/util";
import "./blog.css";

const form = document.querySelector(".filter-form");

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  const loadingTimeout = setTimeout(() => {
    pageContent.classList.add("is-loading");
  }, 300);

  const res = await ajax.get(window.location.href).json();

  clearTimeout(loadingTimeout);

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");
};

const handleFilter = () => {
  const data = new FormData(form);
  let category = data.get("category");

  if (category === "_all_") {
    category = false;
  }

  const url = updateQueryParams([["category", category]]);

  window.history.replaceState({}, "", url);

  updateResults();
};

document.addEventListener("DOMContentLoaded", () => {
  if (form) {
    delegate(".filter-form", "change", handleFilter);
  }
});
